// extracted by mini-css-extract-plugin
module.exports = {"thankYouContainer":"ThankYouMessage_thankYouContainer__yXCir","smileIcon":"ThankYouMessage_smileIcon__E6y2h"};